import { Box, IconButton, Text, useDisclosure } from "@chakra-ui/react";
import React, { useState } from "react";
import { FiFileText } from "react-icons/fi";
import { RiDeleteBin6Line } from "react-icons/ri";
import DeleteFileConfirmModal from "../../../Modals/DeleteFileConfirmModal";

const SingleGstDocument = ({
  name,
  scannedCopyDetected,
  detectedMessage,
  isLast,
}) => {
  const {
    isOpen: isDeleteModalOpen,
    onOpen: openDeleteModal,
    onClose: closeDeleteModal,
  } = useDisclosure();

  const [deleteFileLoader, setDeleteFileLoader] = useState(false);

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      borderBottomWidth={isLast ? "0" : "1px"} // Only show border for non-last items
      borderBottomColor="gray.300"
      paddingY={"2px"}
    >
      <Box display="flex" alignItems="center">
        <FiFileText size={16} color="#FFA500" />
        <Text fontSize={"sm"} ml={2}>
          {name}
        </Text>
      </Box>

      <Box display="flex" alignItems="center">
        {false ? (
          <Text color="red.500" fontSize={"xs"} fontWeight="bold" mr={4}>
            {detectedMessage}
          </Text>
        ) : (
          <>
            <IconButton
              icon={<RiDeleteBin6Line />}
              color={"red.500"}
              variant="ghost"
              aria-label="Delete Document"
              size="md"
              onClick={openDeleteModal} // Trigger delete modal on click
            />
            <DeleteFileConfirmModal
              isOpen={isDeleteModalOpen}
              onClose={closeDeleteModal}
              deleteFileLoader={deleteFileLoader}
              setDeleteFileLoader={() => {
                setDeleteFileLoader(true);
                setTimeout(() => {
                  setDeleteFileLoader(false);
                  closeDeleteModal();
                }, 5000);
              }}
            />
          </>
        )}
      </Box>
    </Box>
  );
};

export default SingleGstDocument;
